
import React from "react";
import "../CSS/styles.css";

const FAQ = () => {
  return (
    <div className="container-fluid inter px-0 vbg mt-5 py-lg-5">
      <div className="container">
        <div className="row py-5 justify-content-center align-items-center">
          <h3 className="bc mb-0 fw-bold text-center">Frequently Asked Questions</h3>
          <div className="col-lg-8 col-12 mt-5">
            <div className="wcc p-4 container-or-table3 int2">
              <h5 className="bc mb-0 fw-bold">What industries do you serve?</h5>
              <p className="gc mb-0 mt-3 lss">TAMBRO serves a wide range of industries including government, financial services, energy, telecommunications, healthcare, manufacturing, and non-profit organizations. Our solutions are adaptable to the specific needs and challenges of each sector.</p>
            </div>
            <div className="wcc p-4 container-or-table3 int2 mt-4">
              <h5 className="bc mb-0 fw-bold">Do you offer services internationally?</h5>
              <p className="gc mb-0 mt-3 lss">Yes, TAMBRO is a global provider with experience working in multiple countries and regions. We have the expertise and capabilities to deliver our services worldwide, adapting to local contexts and requirements..</p>
            </div>
            <div className="wcc p-4 container-or-table3 int2 mt-4">
              <h5 className="bc mb-0 fw-bold">How quickly can you respond to a crisis situation?</h5>
              <p className="gc mb-0 mt-3 lss">Our crisis response team is available 24/7 and can be mobilized rapidly. Depending on the nature and location of the crisis, we can typically provide immediate remote support and deploy personnel on-site within 24-48 hours if needed.</p>
            </div>
            <div className="wcc p-4 container-or-table3 int2 mt-4">
              <h5 className="bc mb-0 fw-bold">What makes TAMBRO different from other security consultants?</h5>
              <p className="gc mb-0 mt-3 lss">TAMBRO differentiates itself through our comprehensive approach that integrates risk management, technology solutions, and capacity building. Our team combines deep technical expertise with practical field experience, and we focus on delivering sustainable solutions that create lasting value for our clients.</p>
            </div>  
          </div>
        </div>
      </div>
    </div>
  )
}

export default FAQ